var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v_pagination"},[_c('el-pagination',{attrs:{"background":"","page-sizes":[10,20,50],"current-page":_vm.page.page,"page-size":_vm.page.num,"layout":"total, sizes, prev, pager, next","total":_vm.page.count},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }